<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnSaveExcel="btnSaveExcel()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Ship No : '"/>
                        <v-col cols="1">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="shipNoChange"
                          ></v-select>
                        </v-col>
                        <i-label :label="'COCW : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="cocw"
                            :items="cocwList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="btnRetrieve"
                          ></v-select>
                        </v-col>
                        <i-label :label="'M-ACT : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-select
                            v-model="mAct"
                            :items="mActList"
                            item-value="mAct"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="btnRetrieve"
                          ></v-select>
                        </v-col>
                        <i-label :label="'POR No : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-text-field
                            dense 
                            outlined 
                            hide-details="auto"
                            clearable 
                            maxLength="8"
                            v-model="porNo"
                            @keyup="uppercase"
                          />
                        </v-col>
                        <i-label :label="'Filter : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-select
                            v-model="filter"
                            :items="filterList"
                            item-value="filter"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="btnRetrieve"
                          ></v-select>
                        </v-col>  
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms6600" 
                    :ref="epms6600Ref"
                    class="hipGridHeight1_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="false"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    :word-wrap-enabled="true"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>  
                    <DxColumn caption="Activity" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="mact" caption="Block" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="Mid PSD" width="6%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="wkstpldt" caption="EXE PSD" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="fastDt" caption="FAST Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="POR No" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="porNo" caption="POR Seq" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="COCW" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="cocwCd" caption="Stage" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="Material Code" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="matlCd" caption="Part No" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="partSpec" caption="Part Spec" width="16%" data-type="string" alignment="center" :allow-editing="false"/>

                    <DxColumn caption="Unit" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="matlUnit" caption="Location Div" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn caption="Unit Weight" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="partUnitWgt" caption="Location Div" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Part Qty" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="partQty" caption="Arrival Qty" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="totalWgt" width="5%" data-type="string" alignment="center" header-cell-template="totalWeight" :allow-editing="false"/>
                    <template #totalWeight>
                      <div>Total<br>Weight</div>
                    </template>
                    <DxColumn data-field="delivQty" width="5%" data-type="string" header-cell-template="dQty" alignment="center" :allow-editing="false"/>
                    <template #dQty>
                      <div>Delivery<br>Qty</div>
                    </template>
                    <DxColumn data-field="issueQty" width="5%" data-type="string" header-cell-template="iQty" alignment="center" :allow-editing="false"/>
                    <template #iQty>
                      <div>Iss<br>Qty</div>
                    </template>
                    <DxColumn data-field="resQty" width="5%" data-type="string" header-cell-template="rQty" alignment="center" :allow-editing="false"/>
                    <template #rQty>
                      <div>Res<br>Qty</div>
                    </template>

                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getShipList } from '@/api/view/hip/6/epms6400.js'
import { getCocwList , getmActList66 , epms6600List , epms6600Xls } from '@/api/view/hip/6/epms6600.js'
import { reportView} from '@/api/view/hip/common/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'

export default {
  name: 'epms6600',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' , 'btnPrint' , 'btnSaveExcel'],
      epms6600Ref: 'epms6600Ref',
      gridMainList: [],

      shipNo: '',
      shipNoList: [],
      revNo: '',
      cocw: '',
      cocwList: [],
      mAct: '',
      mActList: [],
      porNo: '',
      filter: '',
      filterList: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms6600Ref)
    },
  },
  mounted() {
    this.getList()
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
          code: '',
          codegr: '',
          prtCode: 'FILTER_DIV',
          userFlag: 'Y'
        }
        await getShipList(params).then(res => {
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
        })

        await getCocwList(params).then(res => {
          this.cocwList.push('All')
          res.list.forEach(e => {
            this.cocwList.push(e.cocwCd + ' : ' + e.cocwNm)
          });
          this.cocw = this.cocwList[0]
        })
        
        await getCmChildCode(params).then(res => {
          res.list.forEach(e => {
            this.filterList.push(e.codeName)
          });
          this.filter = this.filterList[0]
        })


      } finally {
        this.endLoading()
      }
    },
    async getMActList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
          cocwCd: this.cocw === 'All' ? '%' : this.cocw
        }
        await getmActList66(params).then(res => {
          this.mActList.push('All')
          res.list.forEach(e => {
            this.mActList.push(e.mact)
          });
          this.mAct = this.mActList[0]
        })
      } finally {
        this.endLoading()
      }
    },
    async getMainList(){
      try {
        this.openLoading('searching')
        let cocwGbn = this.cocw
        cocwGbn = cocwGbn.split(' : ')

        let filterGbn = this.filter
        switch(filterGbn){
          case 'ALL': filterGbn ='0'
            break
          case 'Not yet Arrive': filterGbn = '1'
            break
          case 'Arrived': filterGbn = '2'
            break
          case 'Issued': filterGbn = '3'
            break
        }

        let params = {
          shipNo: this.shipNo,
          cocwCd: cocwGbn[0] == 'All' || !cocwGbn[0] ? '%' : cocwGbn[0],
          mact: this.mAct == 'All' || !this.mAct ? '%' : this.mAct,
          porNo: !this.porNo ? '' : this.porNo,
          div: filterGbn
        }
        await epms6600List(params).then(res => {
          console.log(" main >>> " , res)
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            if(e.wkstpldt < e.wkfipldt || e.wkfipldt === '' ){
              e.fastDt = e.wkstpldt
            } else{
              e.fastDt = e.wkfipldt
            }

            e.totalWgt = Math.round((Number(e.partQty) * Number(e.partUnitWgt)) * 10) / 10

            e.delivQty = 0

            if(e.stockYn.endsWith('N') && e.whQty == '0' && Number(e.makeQty) > 0){
              e.delivQty = e.makeQty - e.issueQty - e.resQty
            }
            if(e.stockYn.endsWith('N') && e.makeQty == '0'){
              e.delivQty = e.whQty - e.issueQty - e.resQty
            }
            if(e.stockYn.endsWith('Y') && Number(e.partQty) <= Number(e.issueQty)){
              e.delivQty = 0
            }
            if(e.stockYn.endsWith('Y') && Number(e.whQty) >= Number(e.partQty)){
              e.delivQty = e.partQty - e.issueQty - e.resQty
            }
            if(e.stockYn.endsWith('U')){
              e.delivQty = e.partQty
            }
            if(e.stockYn.endsWith('Y') && Number(e.whQty) < Number(e.partQty)){
              e.delivQty = e.stockQty
            }

            list.push(
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, porNo: e.porNo, mact: e.mact, cocwCd: e.cocwCd, matlCd: e.matlCd, partSpec: e.partSpec,
                matlUnit: e.matlUnit, partUnitWgt: e.partUnitWgt, partQty: e.partQty, issueQty: e.issueQty, resQty: e.resQty,
                fastDt: e.fastDt, wkstpldt: e.wkstpldt, totalWgt: e.totalWgt , delivQty: e.delivQty
              },
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, porNo: e.porSeq, mact: e.block, cocwCd: e.stageCd, matlCd: e.partNo, partSpec: e.partSpec,
                matlUnit: e.bomDivDesc, partUnitWgt: e.bomDivDesc, partQty: e.whQty, issueQty: e.issueQty, resQty: e.resQty,
                fastDt: e.fastDt, wkstpldt: e.wkfipldt, totalWgt: e.totalWgt , delivQty: e.delivQty
              },
            )
          });
          this.gridMainList = list
        })

      } finally {
      this.endLoading()
      }
    },
    shipNoChange(){
      this.getMActList()
    },
    uppercase(){
      if(!this.porNo){
        this.porNo = this.porNo.toUpperCase()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    btnPrint(){
      let cocwGbn = this.cocw
      cocwGbn = cocwGbn.split(' : ')

      let filterGbn = this.filter
      switch(filterGbn){
        case 'ALL': filterGbn ='0'
          break
        case 'Not yet Arrive': filterGbn = '1'
          break
        case 'Arrived': filterGbn = '2'
          break
        case 'Issued': filterGbn = '3'
          break
      }
      const param = {
        fileName: 'epms6600prt.jrxml',
        as_ship_no: this.shipNo,
        as_m_act: this.mAct == 'All' || !this.mAct ? '%' : this.mAct.toUpperCase(),
        as_cocw: cocwGbn[0] == 'All' || !cocwGbn[0] ? '%' : cocwGbn[0],
        as_por_no: !this.porNo ? '%' : this.porNo,
        as_div: filterGbn
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnSaveExcel(){
      let cocwGbn = this.cocw
      cocwGbn = cocwGbn.split(' : ')

      let filterGbn = this.filter
      switch(filterGbn){
        case 'ALL': filterGbn ='0'
          break
        case 'Not yet Arrive': filterGbn = '1'
          break
        case 'Arrived': filterGbn = '2'
          break
        case 'Issued': filterGbn = '3'
          break
      }
      const param = {
        shipNo: this.shipNo,
        mact: this.mAct == 'All' || !this.mAct ? '%' : this.mAct.toUpperCase(),
        cocwCd: cocwGbn[0] == 'All' || !cocwGbn[0] ? '%' : cocwGbn[0],
        porNo: !this.porNo ? '%' : this.porNo,
        div: filterGbn
      }
      epms6600Xls(param)
    },
    //cell merge
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.caption === 'No' || e.column.caption === 'FAST Date' || e.column.caption === 'Part Spec' || e.column.caption === 'Issue Qty' || e.column.caption === 'Res Qty' 
          || e.column.caption === 'Deliv Qty' || e.column.caption === 'Total Wgt'){
          if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')){
            e.cellElement.setAttribute('rowspan', 2)
          }else {
            e.cellElement.style.display = 'none'
          }
        }

        if(e.column.caption === 'Location Div' && e.columnIndex === 8){
          if(e.value === e.component.cellValue(e.rowIndex, e.columnIndex + 1)){
            e.cellElement.setAttribute('colspan', 2)
          }
        }else if(e.column.caption === 'Location Div' && e.columnIndex === 9){
          if(e.value === e.component.cellValue(e.rowIndex, e.columnIndex - 1)){
            e.cellElement.style.display = 'none'
          }
        }

      } else {
        if(e.column.caption === 'Location Div' && e.columnIndex === 5){
          e.cellElement.setAttribute('colspan', 2)
        } else if(e.column.caption === 'Location Div' && e.columnIndex === 6){
          e.cellElement.style.display = 'none'
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>

</style>